import * as React from "react";
import DateUtils from "../../../utils/DateUtils";
import Event from "../../../model/event/Event";
import {RouteComponentProps, withRouter} from "react-router";
import Routes from "../../../navigation/route/Route";
import moment = require("moment");

interface ComponentProps {
	event: Event
}

type Props = ComponentProps & RouteComponentProps<{}>;

class AppointmentCalendarTooltipBody extends React.PureComponent<Props, {}> {
	render() {
		return (
			<React.Fragment>
				<div className={"t-body"} style={{maxWidth: "200px"}}>
					<strong className="d-block">
						{this.props.event.getReferenceTitle()}
					</strong>
					<strong className="d-block">
						{this.props.event.status.label.capitalize()}
					</strong>
					{this.props.event.appointmentType.map(at => <div>Type: {at.getDisplayName()}</div>).orNull}
					<br/>
					<div>
						{moment(this.props.event.start).format(DateUtils.DAILY_PLAN_DATE_FORMAT)} <br/>
						{`${moment(this.props.event.start).format(DateUtils.DAILY_PLAN_TIME_FORMAT)}
						to ${moment(this.props.event.end).format(DateUtils.DAILY_PLAN_TIME_FORMAT)}`}
					</div>
					<br/>
					<div style={{whiteSpace: "pre"}}>{this.props.event.contact.data.fullDetails()}<br/></div>
					{this.props.event.address.map(a => {
						return <div>{a.displayName()}<br/></div>
					}).orNull}
					<br/>
					{this.renderSE()}
					<br/>
					{this.props.event.referenceType.map(jt => {
						return <div>{this.props.event.isLeadAppointment ? "Lead" : "Job"} type: {jt.name}<br/></div>
					}).orNull}
				</div>
				<div className={"t-link"} onClick={() => this.routeToEdit()}>
					View &amp; edit details
				</div>
			</React.Fragment>
		);
	}

	routeToEdit() {
		if (this.props.event.isLeadAppointment) {
			this.props.history.push(Routes.EditLead(this.props.event.referenceNumber))
		}
		else {
			this.props.history.push(Routes.EditJob(this.props.event.referenceNumber))
		}
	}

	renderSE() {
		const seList = this.props.event.salesEngineers.getOrElse([]);
		return (
			<div>
				{`Sales Engineer${!this.props.event.isLeadAppointment ? '(s)' : ''}:`} <br/>
				{seList.length == 0 && "Unassigned"}
				{seList.map(u => u.getDisplayName(true)).map(
					(seName, index) => <div key={index} className="d-block">{seName}</div>)}
			</div>
		)
	}
}

export default withRouter<ComponentProps>(AppointmentCalendarTooltipBody)